export default __webpack_public_path__ + "static/media/roi-banner.2d3fec97.svg";